{
    "AdminControl_PolicyApplied": "Politique appliquée",
    "AdminControl_RecordingPolicyDetails": "Détails de la politique d'enregistrement",
    "AdminControl_DisplayName": "Nom d'affichage :",
    "AdminControl_UserPrincipalName": "Nom d'utilisateur principal",
    "AdminControl_TeamsComplianceRecordingPolicy": "Politique d'enregistrement de la conformité des équipes",
    "AdminControl_PresenceStatus": "État de présence",
    "AdminControl_CopiedToClipboard": "Copié dans le presse-papiers",
    "AdminControl_ResponseSuccess": "Tâche accomplie avec succès",
    "NAME": "AdminControlLanguage"
}